export default "__VITE_ASSET__6ed56905__"